export const randomString = (): string => Math.random().toString(36).substring(7);
